module.exports = __webpack_public_path__ + "assets/lock.d45ddbf3.svg";